// extracted by mini-css-extract-plugin
export default {"controls":"GenericConfirmation_controls__2+Y-k"};